import React from 'react';
import PreviewIndividualGlyph from './PreviewIndividualGlyph';

export enum GlyphType {
  Triangle = 'triangle',
  Square = 'square',
  Diamond = 'diamond',
  Dot = 'dot',
  Circle = 'circle',
  Noop = 'noop',
};

type PreviewGlyphSequenceProps = {
  glyphString: string;
  lineNumber: number;
};

const getMarkupForGlyphs = (glyphString: string, lineNumber: number) => {
  const glyphSections = glyphString.split(/(\([^)]+\))/)
    .map(s => s.trim()).filter(Boolean);

  return glyphSections.flatMap((section, i1) => {
    const isSumBlock = section.startsWith('(');
    const glyphsForSection = section
      .slice(isSumBlock ? 1 : 0, isSumBlock ? -1 : undefined) // slice off the parens if needed
      .split(' ')
      .map((glyph, i2) => 
        <PreviewIndividualGlyph
          key={`${i1}-${i2}`}
          glyphType={glyph as GlyphType}
        />
      );

    return isSumBlock
      ? <div key={i1} className="sumblock">{glyphsForSection}</div>
      : glyphsForSection;
  });
};

const PreviewGlyphSequence = ({ glyphString, lineNumber }: PreviewGlyphSequenceProps) => {
  const glyphMarkup = getMarkupForGlyphs(glyphString, lineNumber);

  return (
    <div className="glyphSequence">
      {glyphMarkup}
    </div>
  );
};

export default PreviewGlyphSequence;